import React from 'react'
import { useIndex, useValue } from '@morningtrain/react-resources'
import ShowIfEnvValueMatches from 'pages/app/cleaning/partials/ShowIfEnvValueMatches'
import StepCategorySection from 'pages/app/cleaning/partials/StepCategorySection'

export default function ConditionalStepCategorySection ({ style, isCompleted }) {
  const categoryId = useValue('category_id')
  const index = useIndex()

  return (
    <ShowIfEnvValueMatches name='cleaning_checkup.active_section' matches={v => (!!v && categoryId === v) || (!v && index === 0)}>
      <div style={style}>
        <StepCategorySection isCompleted={isCompleted} />
      </div>
    </ShowIfEnvValueMatches>
  )
}
